import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { trendingTopicInput, trendingTopicOutput, trendingTopicsList } from 'src/app/core/models/view-model/trending-topics.model';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexFill,
  ApexMarkers,
  ApexYAxis,
  ApexTooltip,
  ApexStates,
  ApexStroke,
  ApexLegend,
  ApexPlotOptions,
  ApexResponsive
} from "ng-apexcharts";
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Logger, MasterHelper } from 'src/app/core/utilities';
//import  moment = require('moment');
import * as moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';
import { FilterViewModel, MasterFilterModel, RegulationFilterModel } from 'src/app/core/models/regulation';
import { RegulationService } from 'src/app/core/services/regulation';
import { FormControl } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { GeneralDataService } from 'src/app/core/services/general/general-data.service';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { Router } from '@angular/router';

export type barChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
  responsive: ApexResponsive;
};
export type areaChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  states: ApexStates;
  yaxis: ApexYAxis;
  responsive: ApexResponsive;
};
export type treeChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  title: ApexTitleSubtitle;
  plotOptions: ApexPlotOptions;
  legend: ApexLegend;
  colors: string[];
  responsive: ApexResponsive;
};

@Component({
  selector: 'app-trending-topics-dashboard',
  templateUrl: './trending-topics-dashboard.component.html',
  styleUrls: ['./trending-topics-dashboard.component.scss']
})
export class TrendingTopicsDashboardComponent implements OnInit {
  @ViewChild("chart")
  chart!: ChartComponent;
  public barChartOptions!: Partial<barChartOptions>;

  //@ViewChild("lineChart") lineChart: ChartComponent;
  public areaChartOptions!: Partial<areaChartOptions>;
  public chartOptions!: Partial<treeChartOptions>;

  savedFilterDate!: string;
  savedFilterArea!: string;
  savedFilterTopTypes!: number;
  topicInput = {} as trendingTopicInput;
  chartData: trendingTopicsList[] = [];
  allChartData!: trendingTopicOutput;
  cloudData: any[] = [];
  isShowDateRange: boolean = false;
  fromDate!: string;
  toDate!: string;
  isLoadingRegulations: boolean = false;
  addOnBlur = true;
  removable = true;
  searchedRegulators: FilterViewModel[] = [];
  searchedCountries: FilterViewModel[] = [];
  searchedTrendingTopics: string[] = [];
  masterFilters!: MasterFilterModel;
  searchRegulatorCntrl: FormControl = new FormControl();
  searchCountryCntrl: FormControl = new FormControl();
  searchTrendingTopicsCntrl: FormControl = new FormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  isTypeChange: boolean = false;
  areaChartHeightPixel: number = 200;
  othersChartHeightPixel: number = 200;
  trendingTopicsList: string[] = [];
  isloadingDataFirstTime: boolean = true;
  toastModel: ToastViewModel;
  isToastShow = false;
  isRegulatorComponentShow=false;
  trndingTopicsRegulationFilter: RegulationFilterModel;

  @ViewChild('regulatorInput')
  regulatorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('regulatorAutocomplete')
  regulatorAutocomplete!: MatAutocomplete;

  @ViewChild('countryInput')
  countryInput!: ElementRef<HTMLInputElement>;
  @ViewChild('countryAutocomplete')
  countryAutocomplete!: MatAutocomplete;

  @ViewChild('trendingTopicInput')
  trendingTopicInput!: ElementRef<HTMLInputElement>;
  @ViewChild('trendingTopicAutocomplete')
  trendingTopicAutocomplete!: MatAutocomplete;

  @ViewChild('trendingComponentIdentifier')
  trendingComponentIdentifier!: ElementRef;
  @ViewChild('topbarIndentifier')
  topbarIndentifier!: ElementRef;
  @ViewChild('chartAreaIdentifire')
  chartAreaIdentifire!: ElementRef;

  landingComponentIndentifire!: ElementRef;
  navComponentIndentifire!: ElementRef;
  selectedBarTopic!: string;
  constructor(private analyticsService: AnalyticsService,
    private regulationService: RegulationService,
    private generalService: GeneralDataService,
    private ref: ChangeDetectorRef,
    private router: Router) {
    this.toastModel = new ToastViewModel();
    this.trndingTopicsRegulationFilter = new RegulationFilterModel();
  }

  ngOnInit(): void {
    this.savedFilterDate = "Last7"
    this.savedFilterArea = "All";
    this.savedFilterTopTypes = 20;
    this.toDate = MasterHelper.getCurrrentDateTime('YYYY-MM-DD').toString();
    this.fromDate = MasterHelper.getDateStr(6);
    this.getMasterFilters();
    this.generalService.getLandingComponentIdentifire().subscribe(res => {
      this.landingComponentIndentifire = res;
      this.calculateChartWindowSize();
    });
  }

  geTredingTopics(): void {
    this.isRegulatorComponentShow=false;
    this.isLoadingRegulations = true;
    this.topicInput.fromDate = this.fromDate;
    this.topicInput.toDate = this.toDate;
    this.topicInput.totalTopic = this.savedFilterTopTypes;
    this.topicInput.isTopTypeChange = this.isTypeChange;
    this.analyticsService.GetTrendingTopics(this.topicInput).subscribe((data: trendingTopicOutput) => {
      this.allChartData = data;
      this.chartData = this.allChartData.trendingTopic;
      this.getAutoCompleteTrendingTopicList();
      this.cloudFontSizeChange();
      this.initBarChart();
      if (this.isTypeChange == false) {
        this.initAreaChart();
      }
      this.isLoadingRegulations = false;
      this.isTypeChange = false;
      this.initTreeChart();
      this.topicInput.isTopTypeChange = this.isTypeChange;
    });
  }
  getAutoCompleteTrendingTopicList() {
    this.trendingTopicsList =MasterHelper.sortArray(this.chartData.map(a => a.topics),'asc') ;
    this.searchedTrendingTopics = this.trendingTopicsList;
    this.searchTrendingTopicsCntrl.valueChanges.subscribe((term: any) => {
      this.searchedTrendingTopics = term ? this.filterTrendingTopics(term) : this.trendingTopicsList;
    });
  }
  initBarChart() {
    this.barChartOptions = {
      series: [{
        data: this.chartData.map(obj => obj.value),
      },
      ],
      chart: {
        height: this.othersChartHeightPixel,
        width: '100%',
        type: "bar",
        // height: 16 * 25,
        toolbar: {
          show: false
        },
        events: {
          dataPointSelection: (event, chartContext, config) => {
            this.getRegulator(chartContext.w.globals.labels[config.dataPointIndex]);
          }
        }
      },
      xaxis: {
        categories: this.chartData.map(obj => obj.topics),
        labels: {
          show: true,
          hideOverlappingLabels: false,
          trim: false,
          minHeight: undefined,
          maxHeight: 120,
          style: {
            colors: [],
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 400,
            cssClass: 'apexcharts-yaxis-label',
          },
        },
      },
      responsive: {
        breakpoint: 16 * 25,
        options: {
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          legend: {
            position: 'bottom',
          },
          dataLabels: {
            offsetX: 12,
            offsetY: 0,
          },
        },
      }
    };
  }
  initAreaChart() {
    this.areaChartOptions = {
      series: this.allChartData.topFiveTrendingTopic,

      chart: {
        height: this.areaChartHeightPixel,
        type: "area",
        toolbar: {
          show: false
        },
      },
      dataLabels: {
        enabled: false,

      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      xaxis: {
        type: "datetime",
        categories: this.allChartData.topFiveDatelist,
        tooltip: {
          enabled: false,
        },
      },
      tooltip: {
        enabled: false,
        enabledOnSeries: undefined,
        marker: {
          show: false,
        }
      },
      yaxis: {
        tooltip: {
          enabled: false
        },
      },
    };
  }
  initTreeChart() {
    let treeChartData:any = [];
    this.chartData.forEach(element => {
      treeChartData.push({ x: this.trimWord(element.topics), y: element.value })
    });
    this.chartOptions = {
      series: [
        {
          data: treeChartData
        },
      ],
      legend: {
        show: false
      },
      chart: {
        height: this.othersChartHeightPixel,
        type: "treemap",
        toolbar: {
          show: false
        },
      },
      plotOptions: {
        treemap: {
          distributed: true,
          enableShades: false
        }
      }
    };
  }

  @HostListener('window:resize', ['$event'])
  onResize(event:any) {
    this.calculateChartWindowSize();
    this.cloudFontSizeChange();
  }

  cloudFontSizeChange() {
    let i = 0;
    let totalTopics = this.savedFilterTopTypes;
    let sum = 0;
    for (let i = 0; i <= this.chartData.length - 1; i++) {
      sum = Number(sum) + Number(this.chartData[i].value)
    }
    let avg = sum / this.chartData.length;
    this.cloudData = this.chartData.map(function (d) {
      if (window.innerWidth < 1560) {
        if (totalTopics >= 30) {
          return { text: d.topics, value: (d.value / avg) * 10, tooltipText: d.topics, };
        }
        else {
          return { text: d.topics, value: (d.value / avg) * 12, tooltipText: d.topics, };
        }
      }
      else if (window.innerWidth < 1440) {
        if (totalTopics >= 30) {
          return { text: d.topics, value: (d.value / avg) * 11, tooltipText: d.topics, };
        }
        else {
          return { text: d.topics, value: (d.value / avg) * 15, tooltipText: d.topics, };
        }
      }
      else {
        if (totalTopics >= 30) {
          return { text: d.topics, value: (d.value / avg) * 15, tooltipText: d.topics, };
        }
        else {
          return { text: d.topics, value: (d.value / avg) * 20, tooltipText: d.topics, };
        }
      }
    });
  }

  calculateChartWindowSize() {
    if (this.landingComponentIndentifire) {
      const totalConponentWindowSize = window.innerHeight - (window.innerHeight - this.trendingComponentIdentifier.nativeElement.offsetHeight);
      const topbarSize = this.topbarIndentifier.nativeElement.offsetHeight;
      this.areaChartHeightPixel = Number(((totalConponentWindowSize - topbarSize) * 35) / 100);
      this.othersChartHeightPixel = Number(((totalConponentWindowSize - topbarSize) * 52) / 100);
      if(this.isloadingDataFirstTime){
        this.geTredingTopics();
        this.isloadingDataFirstTime=false;
      }
      else{
        this.initAreaChart();
        this.initBarChart();
        this.cloudFontSizeChange();
        this.initTreeChart();
      }
      this.ref.markForCheck();
      this.ref.detectChanges();
    }
  }

  applyDateFilters(value:string) {
    if (value === "DateRange") {
      this.isShowDateRange = true;
    }
    else {
      this.isShowDateRange = false;
      if (value === "Last30") {
        this.toDate = MasterHelper.getCurrrentDateTime('YYYY-MM-DD').toString();
        this.fromDate = MasterHelper.getDateStr(29);
      }
      else if (value === "Last7") {
        this.toDate = MasterHelper.getCurrrentDateTime('YYYY-MM-DD').toString();
        this.fromDate = MasterHelper.getDateStr(6);
      }
      this.geTredingTopics();
    }
  }
  applyDateRange() {
    if (this.toDate) {
      this.toDate = moment(this.toDate).format('YYYY-MM-DD').toString();
      this.fromDate = moment(this.fromDate).format('YYYY-MM-DD').toString();
      this.geTredingTopics();
    }
  }

  getMasterFilters(): void {
    this.regulationService.getMasterFilters().subscribe((data: MasterFilterModel) => {
      this.masterFilters = data;
      this.searchedRegulators = this.masterFilters.regulators;
      this.searchedCountries = this.masterFilters.countries;

      this.searchRegulatorCntrl.valueChanges.subscribe((term: any) => {
        this.searchedRegulators = term ? this.filterRegulators(term) : this.masterFilters.regulators;
      });
      this.searchCountryCntrl.valueChanges.subscribe((term: any) => {
        this.searchedCountries = term ? this.filterCountry(term) : this.masterFilters.countries;
      });

    },
      (error: HttpErrorResponse) => {
        Logger.log(this.constructor.name, error.error);
      }
    );
  }

  filterRegulators(search: string): any {
    return this.masterFilters.regulators.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterCountry(search: string): any {
    return this.masterFilters.countries.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterTrendingTopics(search: string): any {
    return this.trendingTopicsList.filter(option =>
      option.toLowerCase().includes(search.toLowerCase())
    );
  }

  removeRegulator(regulator: string): void {
    if (!this.topicInput.regulator) {
      this.topicInput.regulator = [];
    }
    const index = (this.topicInput.regulator as string[]).indexOf(
      regulator
    );
    if (index >= 0) {
      (this.topicInput.regulator as string[]).splice(index, 1);
    }
  }

  addRegulator(event: MatChipInputEvent): void {
    if (!this.regulatorAutocomplete.isOpen) {
      const input = event.input;

      const filteRow = this.searchedRegulators.filter(option =>
        option.name.toLowerCase() == event.value.toLowerCase()
      );
      if (filteRow.length > 0) {
        const value = filteRow[0].name;
        if (!this.topicInput.regulator) {
          this.topicInput.regulator = [];
          this.topicInput.regulator.push(value);
        }
        else if ((value || '').trim()) {
          (this.topicInput.regulator as string[]).push(value);
        }
      }

      // Reset the input value
      if (input) {
        input.value = '';
      }
      this.searchRegulatorCntrl.setValue(null);
    }
  }

  selectedRegulatorEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.topicInput.regulator) {
      const filteRow = this.topicInput.regulator.filter(option =>
        option.toLowerCase() == event.option.viewValue.toLowerCase()
      );
      if (filteRow && filteRow.length > 0) {
        this.warningAlert("This regulator already selected");
      }
      else {
        this.topicInput.regulator.push(event.option.viewValue);
      }
    } else {
      this.topicInput.regulator = [];
      this.topicInput.regulator.push(event.option.viewValue);
    }
    this.regulatorInput.nativeElement.value = '';
    this.searchRegulatorCntrl.setValue(null);
    this.searchRegulatorCntrl.disable();
    this.searchRegulatorCntrl.enable();
  }

  removeCountry(country: string): void {
    if (!this.topicInput.country) {
      this.topicInput.country = [];
    }
    const index = (this.topicInput.country as string[]).indexOf(
      country
    );
    if (index >= 0) {
      (this.topicInput.country as string[]).splice(index, 1);
    }
  }

  addCountry(event: MatChipInputEvent): void {
    if (!this.countryAutocomplete.isOpen) {
      const input = event.input;
      const filteRow = this.searchedCountries.filter(option =>
        option.name.toLowerCase() == event.value.toLowerCase()
      );
      if (filteRow.length > 0) {
        const value = filteRow[0].name;
        if (!this.topicInput.country) {
          this.topicInput.country = [];
          this.topicInput.country.push(value);
        }
        else if ((value || '').trim()) {
          (this.topicInput.country as string[]).push(value);
        }
      }

      if (input) {
        input.value = '';
      }
      this.searchCountryCntrl.setValue(null);
    }
  }

  selectedCountryEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.topicInput.country) {
      const filteRow = this.topicInput.country.filter(option =>
        option.toLowerCase() == event.option.viewValue.toLowerCase()
      );
      if (filteRow && filteRow.length > 0) {
        this.warningAlert("This country already selected");
      }
      else {
        this.topicInput.country.push(event.option.viewValue);
      }

    } else {
      this.topicInput.country = [];
      this.topicInput.country.push(event.option.viewValue);
    }
    this.countryInput.nativeElement.value = '';
    this.searchCountryCntrl.setValue(null);
    this.searchCountryCntrl.disable();
    this.searchCountryCntrl.enable();
  }

  removeTrendingTopic(topic: string): void {
    if (!this.topicInput.trendingTopics) {
      this.topicInput.trendingTopics = [];
    }
    const index = (this.topicInput.trendingTopics as string[]).indexOf(
      topic
    );
    if (index >= 0) {
      (this.topicInput.trendingTopics as string[]).splice(index, 1);
    }
  }

  selectedTrendingTopicEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.topicInput.trendingTopics) {
      const filteRow = this.topicInput.trendingTopics.filter(option =>
        option.toLowerCase() == event.option.viewValue.toLowerCase()
      );
      if (filteRow && filteRow.length > 0) {
        this.warningAlert("This trending topic already selected");
      }
      else {
        this.topicInput.trendingTopics.push(event.option.viewValue);
      }
    } else {
      this.topicInput.trendingTopics = [];
      this.topicInput.trendingTopics.push(event.option.viewValue);
    }
    this.trendingTopicInput.nativeElement.value = '';
    this.searchTrendingTopicsCntrl.setValue(null);
    this.searchTrendingTopicsCntrl.disable();
    this.searchTrendingTopicsCntrl.enable();
  }

  // public generateData(baseval, count, yrange) {
  //   var i = 0;
  //   var series = [];
  //   while (i < count) {
  //     var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
  //     var y =
  //       Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
  //     var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

  //     series.push([x, y, z]);
  //     baseval += 86400000;
  //     i++;
  //   }
  //   return series;
  // }
  changeTopTypes() {
    this.isTypeChange = true;
    this.geTredingTopics();
  }
  trimWord(text:string) {
    var length = 20;
    var trimmedString = text.length > length ?
      text.substring(0, length - 3) + "..." : text;
    return trimmedString;
  }
  warningAlert(msg: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }
  getRegulator(topicName:string) {
    this.trndingTopicsRegulationFilter.Country=this.topicInput?.country;
    this.trndingTopicsRegulationFilter.MappingID=this.topicInput?.regulator;
    this.trndingTopicsRegulationFilter.FromDate=this.topicInput?.fromDate;
    this.trndingTopicsRegulationFilter.ToDate=this.topicInput?.toDate;
    this.trndingTopicsRegulationFilter.Filters.RuleTopic=[topicName];
    this.trndingTopicsRegulationFilter.FilterType='Other';
    this.trndingTopicsRegulationFilter.IsTrendingDashboard=true;
    this.selectedBarTopic=topicName;
    this.isRegulatorComponentShow=true;
  }
}
